import { gql, graphql } from "react-apollo"
import { GetAttractLoopsQuery } from "./withAttractLoops"
import type { AttractLoop } from "../types"

const MUTATE_UPDATE_ATTRACT_LOOP = gql`
  mutation UpdateAttractLoop($id: ID!, $attractLoop: AttractLoopInput!) {
    updateAttractLoop(id: $id, attractLoop: $attractLoop) {
      id
      title
    }
  }
`

const mutateUpdateAttractLoop = graphql(MUTATE_UPDATE_ATTRACT_LOOP, {
  name: "mutateUpdateAttractLoop",
  options: {
    refetchQueries: [{ query: GetAttractLoopsQuery, variables: { query: "" } }]
  },
  props: ({ mutateUpdateAttractLoop }) => ({
    updateAttractLoop: (id: string, { title }: AttractLoop) =>
      mutateUpdateAttractLoop({
        variables: { id, attractLoop: { title } }
      })
  })
})

export default mutateUpdateAttractLoop



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/mutateUpdateAttractLoop.js